"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var objectFieldTemplateStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        header: (_b = {
                margin: '16px auto 28px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column-reverse'
            },
            _b[breakpoints.up('sm')] = {
                display: 'block',
            },
            _b),
        root: {
            padding: '0 10px',
            flexBasis: 'initial',
        },
        child: {
            padding: '0 15px',
            marginBottom: 25,
        },
        singleField: {
            padding: '0 25px',
            marginBottom: '20px',
        },
    });
}, { name: 'GqlCheckout_objectFieldTemplate' });
exports.default = objectFieldTemplateStyles;
